var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.box],on:{"click":function($event){return _vm.$router.push({
    name: 'Article',
    params: {
      articleId: _vm.data.articleId
    }
  })}}},[(!_vm.data.isEmpty)?[_c('img',{class:_vm.$style.cover,attrs:{"src":_vm.data.cover,"alt":""}}),_vm._v(" "+_vm._s(_vm.data.title)+" "+_vm._s(_vm.data.subtitle)+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }